import { CategoricalDonut } from '../../Common/Charts/CategoricalDonut';
import { useEstablishmentLocationChartsDataContext } from './hooks/useEstablishmentLocationChartsDataContext';
import { coresMescladasArray } from '../../Common/styles/colors';

export const LocationByNature = () => {
    const { chartData } = useEstablishmentLocationChartsDataContext();

    const porNatureza = chartData?.byNature || [];

    const subtitles = porNatureza.map((item) => item.descricao);
    const values = porNatureza.map((item) => item.total);

    const colors = subtitles.map(
        (_, index) =>
            coresMescladasArray[index % coresMescladasArray.length]
    );

    return (
        <CategoricalDonut
            title="Distribuição por Natureza"
            values={values}
            subtitles={subtitles}
            colors={colors}
        />
    );
};